<div class="course-details">
  <div *ngIf="showSpinner" class="progress-spinner">
    <mat-spinner></mat-spinner>
  </div>
  <div class="intro">
    <h2 class="mat-display-2">Demokratiewerkstatt Details</h2>
  </div>
  <div class="details" *ngIf="demokratiewerkstatt !== undefined">
    <div class="main_detail">
      <div class="info_proj">
        <a routerLink="/demokratiewerkstatt" class="list">Zu den Demokratiewerkstattlisten</a>
        <a *ngIf="isAdmin()" routerLink="/demokratiewerkstatt/list" class="list">Zurück zur Demokratiewerkstattliste</a>
      </div>
      <div class="titleLogo">
        <div class="logo_proj">
          <div>
            <img alt="" [src]="demokratiewerkstatt.demokratiewerkstatt_icon_url?.trim() ? demokratiewerkstatt.demokratiewerkstatt_icon_url : image"
                 [style.display]="demokratiewerkstatt.demokratiewerkstatt_icon_url === 'https://res.cloudinary.com/dyekwrvwe/image/upload/v1709258959/placeholder_b3miif.jpg' ? 'none' : 'block'">
          </div>
        </div>
        <div>
          <mat-card-title>{{ demokratiewerkstatt.title }}</mat-card-title>
        </div>
      </div>

      <div class="proj_date">
        Wann: {{ demokratiewerkstatt.start_date | date }} - {{ demokratiewerkstatt.end_date | date }}
      </div>

      <div class="proj_date">Wo: {{ demokratiewerkstatt.location }}</div>

      <div class="img_proj" *ngIf="demokratiewerkstatt.demokratiewerkstatt_image_url !== ''">
        <div>
          <img [src]="demokratiewerkstatt.demokratiewerkstatt_image_url" alt=""/>
        </div>
      </div>


      <div class="desc_proj">
        <div [innerHTML]="demokratiewerkstatt.content" class="preview-content"></div>
      </div>
      <div *ngIf="demokratiewerkstatt.sponsor_images_url && demokratiewerkstatt.sponsor_images_url.length > 0"
           class="partners-img"
           style="width: 100%;">
        <h1>Die Demokratiewerkstatt ist eine Kooperation von :</h1>
        <div class="carousel-container">
          <img class="carousel" *ngFor="let imageUrl of demokratiewerkstatt.sponsor_images_url" [src]="imageUrl" alt=""
               [style.display]="imageUrl ? 'block' : 'none'"/>
        </div>
      </div>
      <div *ngIf="demokratiewerkstatt.partners_images_url && demokratiewerkstatt.partners_images_url.length > 0"
           class="partners-img">
        <h1>Kooperationspartner</h1>
        <div class="carousel-container ">
          <img class="carousel" *ngFor="let imageUrl of demokratiewerkstatt.partners_images_url" [src]="imageUrl"
               alt="">
        </div>
      </div>
      <mat-card-actions align="end" *ngIf="isAdmin()">
        <button mat-button (click)="editProject()">Bearbeiten</button>
        <button mat-button (click)="deleteProject(demokratiewerkstatt)">Löschen</button>
      </mat-card-actions>
    </div>
  </div>
</div>
